var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBubbleTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 25,
    viewBox: "0 0 17 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82303 16.584L2.80774 16.5738L2.79175 16.5647C1.54634 15.8607 0.658579 14.6174 0.519282 13.306C0.383909 12.0315 0.945913 10.5895 2.81065 9.42399C2.97628 9.32046 3.20289 9.18706 3.4749 9.02692C4.45473 8.45006 6.02375 7.52634 7.45452 6.40287C8.3729 5.68173 9.26086 4.85928 9.92282 3.96442C10.4793 3.21208 10.8953 2.38226 11.0125 1.5L15.0455 1.5L15.0456 24.5L11.0121 24.5C10.8931 23.6159 10.4702 22.7852 9.907 22.0332C9.23711 21.1388 8.33985 20.3167 7.41582 19.5961C6.0842 18.5577 4.61428 17.6735 3.65121 17.0942C3.29486 16.8798 3.00791 16.7072 2.82303 16.584Z",
    fill: "white",
    stroke: "#8A8A8A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 25,
    width: 25,
    height: 6,
    transform: "rotate(-90 11 25)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleTip);
export default __webpack_public_path__ + "static/media/chat-bubble-tip.df67dbcb9a331d562cdc5854a56f1963.svg";
export { ForwardRef as ReactComponent };